/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AuthorizationGroupData model module.
 * @module model/AuthorizationGroupData
 * @version 1.0
 */
class AuthorizationGroupData {
    /**
     * Constructs a new <code>AuthorizationGroupData</code>.
     * @alias module:model/AuthorizationGroupData
     */
    constructor() { 
        
        AuthorizationGroupData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AuthorizationGroupData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AuthorizationGroupData} obj Optional instance to populate.
     * @return {module:model/AuthorizationGroupData} The populated <code>AuthorizationGroupData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AuthorizationGroupData();

            if (data.hasOwnProperty('groupNo')) {
                obj['groupNo'] = ApiClient.convertToType(data['groupNo'], 'Number');
            }
            if (data.hasOwnProperty('groupName')) {
                obj['groupName'] = ApiClient.convertToType(data['groupName'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AuthorizationGroupData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AuthorizationGroupData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['groupName'] && !(typeof data['groupName'] === 'string' || data['groupName'] instanceof String)) {
            throw new Error("Expected the field `groupName` to be a primitive type in the JSON string but got " + data['groupName']);
        }

        return true;
    }


}



/**
 * @member {Number} groupNo
 */
AuthorizationGroupData.prototype['groupNo'] = undefined;

/**
 * @member {String} groupName
 */
AuthorizationGroupData.prototype['groupName'] = undefined;






export default AuthorizationGroupData;

